import * as React from 'react';

const ActingOrgContext = React.createContext<string | undefined>(undefined);

export function ActingOrg({
  orgId,
  children,
}: {
  orgId: string;
  children: React.ReactNode;
}) {
  return (
    <ActingOrgContext.Provider value={orgId}>{children}</ActingOrgContext.Provider>
  );
}

export function useActingOrg() {
  return React.useContext(ActingOrgContext);
}
